import React from 'react'

import Button, { ButtonProps } from './Button'

import './ButtonStyles.less'

const EnterButton: React.FC<ButtonProps> = ({ className, ...props }) => {
  return (
    <div className={'enter_button ' + className}>
      <Button {...props} />
      <h4 className="label">or press ENTER↵</h4>
    </div>
  )
}

export default EnterButton
